import getIcon from 'src/components/icons';
import { getAEMBasepath } from './basepaths';
import {
  currentEnvironment,
  ENVIRONMENTS,
  isPreviewMode,
} from './runtime-config';

export { hardRedirectTo } from './navigation';

export const checkAndAddProps = (
  sourceProps: any,
  targetProps: any,
  propNames: string[],
) =>
  propNames.forEach(
    propName =>
      sourceProps.hasOwnProperty(propName) &&
      (targetProps[propName] = sourceProps[propName]),
  );

export function getStringBetween(
  inputString: string,
  startString: string,
  endString: string,
) {
  const start = inputString.indexOf(startString) + startString.length;
  const end = inputString.indexOf(endString, start);
  let stringBetween = '';
  try {
    stringBetween = inputString.substring(start, end);
  } catch (e) {
    console.error('Error in getStringBetween function', e, inputString);
  }

  return stringBetween;
}

export function replaceStringBetween(
  inputString: string,
  startString: string,
  endString: string,
  replacementString: string,
) {
  const start = inputString.indexOf(startString);
  const end = inputString.lastIndexOf(endString);

  let replacedString = '';
  try {
    const stringBetween = inputString.substring(start, end + endString.length);
    replacedString = inputString.replace(stringBetween, replacementString);
  } catch (e) {
    console.error('Error in replaceStringBetween function', e, inputString);
  }

  return replacedString;
}

export function getTimestamp() {
  const timeNow = new Date();
  return `${
    timeNow.getHours() < 10 ? `0${timeNow.getHours()}` : `${timeNow.getHours()}`
  }:\
${
  timeNow.getMinutes() < 10
    ? `0${timeNow.getMinutes()}`
    : `${timeNow.getMinutes()}`
}:\
${
  timeNow.getSeconds() < 10
    ? `0${timeNow.getSeconds()}`
    : `${timeNow.getSeconds()}`
}:\
${timeNow.getMilliseconds()}`;
}

export function debugLog(...args: any[]) {
  if (currentEnvironment !== ENVIRONMENTS.PROD) {
    console.log('-->', getTimestamp(), ...args);
  }
}

export function debugError(...args: any[]) {
  if (currentEnvironment !== ENVIRONMENTS.PROD) {
    console.error('-->', getTimestamp(), ...args);
  }
}

export function checkCardBadge(props: any) {
  if (props.hasOwnProperty('badge') && props.badge) {
    if (props.badge.hasOwnProperty('icon') && props.badge.icon) {
      const C = getIcon(props.badge.icon);
      props.badge.iconChild = <C />;
    }

    if (props.badge.hasOwnProperty('skin') && props.badge.skin) {
      const badgeStatuses = [
        'general',
        'neutral',
        'promotional',
        'success',
        'error',
        'warning',
      ];
      if (badgeStatuses.includes(props.badge.skin.toLowerCase())) {
        props.badge.status = props.badge.skin;
      } else {
        props.badge.status = 'general';
      }
      delete props.badge.skin;
    }
  }
}

export const scrollToSection = (id: string) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({
      block: 'start',
      behavior: 'smooth',
    });
    window.location.hash = `#${id}`;
  }
};

export function getContentPath(route: string, locale: string) {
  let pageRegion = locale.split('-')[1]?.toLowerCase(); // default to gb
  const pageLanguage = locale.split('-')[0]?.toLowerCase(); // default to en
  const basePaths = getAEMBasepath();
  const basePath = isPreviewMode ? basePaths.preview : basePaths.main;
  const isLocal = currentEnvironment === ENVIRONMENTS.LOCAL;

  let path = '';

  if (route === '/') {
    if (isLocal) {
      path = `content/vaa-home/${pageRegion}/${pageLanguage}.model.json`;
    } else {
      path = `${pageRegion}/${pageLanguage}.model.json`;
    }
  } else {
    if (isLocal) {
      path = `content/vaa-home/${pageRegion}/${pageLanguage}${route}.model.json`;
    } else if (isPreviewMode) {
      path = route;
    } else {
      path = `${pageRegion}/${pageLanguage}${route}.model.json`;
    }
  }

  const backendUrl = (basePath + path).replace(/([^:]\/)\/+/g, '$1');
  return backendUrl;
}

export const removeHTMLTags = (str: string) => {
  if (typeof str !== 'string') return str;
  return str
    .replace(/<\/?[^>]+(>|$)/g, '')
    .replace(/\r/g, '')
    .replace(/\n/g, '');
};
